<template>

    <v-hover>
        <template v-slot:default="{ hover }">

            <v-card dark class="xxs:!w-[200px] xxs:!min-w-[200px] xxs:!max-w-[200px] !w-80   !h-96 p-5 xxs:!h-[260px] rounded-xl !shadow-none !border-[1px] !z-10   "
                :class="`${routeLink}-border`">
                <v-img :src="userDetail.image" class="!absolute top-0 left-0 rounded-xl !border-0 !shadow-none" cover
                    width="100%" height="100%" gradient="to bottom, transparent , black" />
                <v-icon :color="userDetail.status == 'online' ? '#00f244' : 'grey darken-1'" size="14"
                    class="float-right ">
                    mdi-circle
                </v-icon>
                <div class="bottom-0 absolute left-0 m-3" v-if="!hover">
                    <h2 class="text-white font-Inter font-medium text-lg capitalize">{{ userDetail.name }}</h2>
                    <p class="text-white font-Inter font-medium text-xs">{{ userDetail.age }} Y</p>
                </div>
                <v-fade-transition>
                    <v-overlay v-if="hover" absolute :color="colorAsRoute">
                        <h2 class="text-black text-center font-Inter font-semibold text-xl capitalize">{{
                            userDetail.name
                        }}</h2>
                        <v-btn rounded outlined
                            class="!capitalize !left-1/2 !-translate-x-1/2 !font-Inter !font-medium !text-black hover:!text-white !transition-all !duration-300"
                            @click="displayProfile(userDetail)">View Profile</v-btn>
                    </v-overlay>
                </v-fade-transition>
            </v-card>
        </template>
    </v-hover>
</template>
<script>
export default {
    props: {
        userDetail: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            overlay: false,
        }
    },
    methods: {
        displayProfile(userData) {
            this.$emit('showProfile', userData)
        }
    },
    computed: {
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        }
    },
}
</script>
<style scoped>
.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}
</style>
